import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonFooter, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonLoading, IonModal, IonNote, IonPage, IonRefresher, IonRefresherContent, IonSlide, IonSlides, IonTextarea, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import BeautyStars from 'beauty-stars';
import { alertCircle, arrowBack, helpCircle, list } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { avaliarOperacao, listaOperacao, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './Operacoes.css';

const Operacoes: React.FC = () => {

  const history = useHistory();
  const [aba, setAba] = useState("proximos");
  const [arrayOperacoes, setArrayOperacoes] = useState<any>([]);
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const [operacaoId, setOperacaoId] = useState("");
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [operacaopk, setOperacaopk] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [valorEstrela, setValorEstrela] = useState(0);
  const [abrirAvaliar, setAbrirAvaliar] = useState(false);
  const [textoEstrela, setTextoEstrela] = useState("Selecione");
  const [comentario, setComentario] = useState("");
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    loadItens();
    setEsconderMenu(false);
  });

  let slides = useRef(document.createElement('ion-slides'));

  const nextSlide = () => {
    slides.current.getActiveIndex().then(
      isEnd => {
        if (isEnd === 1)
          setAba("anteriores")
        else
          setAba("proximos")
      }
    );
  }

  function pisca(valor: string) {
    if (valor === "Em andamento") return "pisca piscaverde";
    else return "pisca";
  }

  function carregarDetalhes(operacaoid: any) {
    setChamadaRealizada(false);
    history.push("operacoes/acompanhar", { operacaoid: operacaoid });
  }


  function ajustaTextoEstrela(value: any) {
    if (value === 1) setTextoEstrela("Muito ruim");
    if (value === 2) setTextoEstrela("Ruim");
    if (value === 3) setTextoEstrela("Normal");
    if (value === 4) setTextoEstrela("Bom");
    if (value === 5) setTextoEstrela("Excelente");
  }

  function avaliar() {
    const atualizar = async () => {
      requestService(avaliarOperacao.url, {
        method: avaliarOperacao.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify({
          "id": operacaoId,
          "avaliacao": valorEstrela + "",
          "comentario": comentario ? comentario + "" : "Sem comentário."
        }),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (response.message) {
            console.log(response);
            setAbrirAvaliar(false);
            carregarOperacoes();
          }
        },
        (error: any) => {
          console.log(error);
        });
    }

    if (valorEstrela !== 0) {
      setAlertaPreenchimento(false);
      atualizar();
    }
    else {
      setAlertaPreenchimento(true);
    }

  }


  const loadItens = () => {

    if (!chamadaRealizada) {
      setChamadaRealizada(true);
      carregarOperacoes();
    }

    if (arrayOperacoes === undefined || arrayOperacoes.length === 0) {
      return (
        <IonCard key="primeira">
          <IonCardHeader >
            <IonCardTitle>Aqui aparecem os operacoes de entregas e serviços</IonCardTitle>
            <IonCardSubtitle></IonCardSubtitle>
            <IonLabel></IonLabel>
          </IonCardHeader>
          <IonCardContent>
          </IonCardContent>
        </IonCard>
      );
    }

    return arrayOperacoes.map((value: any, index: any, arr: any) =>
      (index === 0 || (arr[index - 1] && new Date(value.dataInicio).toLocaleString('pt-BR').substring(0, 10) !== new Date(arr[index - 1].dataInicio).toLocaleString('pt-BR').substring(0, 10))) ?
        (<>
          <IonCard className={"card"} key={value.dataInicio + index.toString()}>
            <IonCardHeader key={value.dataInicio}>
              <IonCardTitle>
                <div className={"cabecalho"} >{new Date(value.dataInicio).toLocaleString('pt-BR').substring(0, 10) === new Date().toLocaleString('pt-BR').substring(0, 10) ? "Hoje" : new Date(value.dataInicio).toLocaleString('pt-BR').substring(0, 10)}</div>
              </IonCardTitle>
            </IonCardHeader>
          </IonCard>
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>{value.descricaoAgendamento}</IonCardTitle>
              <IonCardSubtitle hidden={!value.nomeProjeto}>
                <IonBadge color="primary" >{value.nomeProjeto}</IonBadge>
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <div>
                <IonLabel>Empresa: {value.empresaNome || "não identificada"}
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (value.empresaTelefone)}>
                    <IonIcon slot="icon-only" icon={helpCircle} />
                  </a>
                </IonLabel>
              </div>
              <div>
                <IonLabel>Prestador: {value.motoristaNome || "não identificada"}</IonLabel>
              </div>
              <div>
                <IonLabel>Duração: {tempoCorrido(new Date(value.dataInicio), (value.dataEncerramento ? new Date(value.dataEncerramento) : new Date()))}</IonLabel>
              </div>
              <IonButton fill='clear' slot="end" onClick={() => { carregarDetalhes(value.pk.replaceAll(/#/g, '%23')); }}>Ver Detalhes</IonButton>
              <IonButton disabled={value.avaliacaoCliente} fill='clear' slot="end" onClick={() => { setAbrirAvaliar(true); setOperacaoId(value.pk.replaceAll(/#/g, '%23')); value.avaliacaoCliente ? setValorEstrela(value.avaliacaoCliente) : setValorEstrela(0); setComentario(value.comentarioCliente); console.log(value.comentarioCliente) }}>{value.avaliacaoCliente ?



                <BeautyStars size="10px"
                  value={value.avaliacaoCliente}
                  editable={false}
                />


                : "Avaliar"}</IonButton>

              <div className="status">
                <IonLabel>{value.status}</IonLabel>
                <div className={pisca(value.status)}></div>
              </div>
            </IonCardContent>
          </IonCard>
        </>
        ) :
        (
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>{value.descricaoAgendamento}</IonCardTitle>
              <IonCardSubtitle hidden={!value.nomeProjeto}>
                <IonBadge color="primary" >{value.nomeProjeto}</IonBadge>
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <div>
                <IonLabel>Empresa: {value.empresaNome || "não identificada"}
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (value.empresaTelefone)}>
                    <IonIcon slot="icon-only" icon={helpCircle} />
                  </a>
                </IonLabel>
              </div>
              <div>
                <IonLabel>Prestador: {value.motoristaNome || "não identificada"}</IonLabel>
              </div>
              <div>
                <IonLabel>Duração: {tempoCorrido(new Date(value.dataInicio), (value.dataEncerramento ? new Date(value.dataEncerramento) : new Date()))}</IonLabel>
              </div>
              <IonButton fill='clear' slot="end" onClick={() => { carregarDetalhes(value.pk.replaceAll(/#/g, '%23')); }}>Ver Detalhes</IonButton>
              <IonButton disabled={value.avaliacaoCliente} fill='clear' slot="end" onClick={() => { setAbrirAvaliar(true); setOperacaoId(value.pk.replaceAll(/#/g, '%23')); value.avaliacaoCliente ? setValorEstrela(value.avaliacaoCliente) : setValorEstrela(0); setComentario(value.comentarioCliente); console.log(value.comentarioCliente) }}>{value.avaliacaoCliente ?



                <BeautyStars size="10px"
                  value={value.avaliacaoCliente}
                  editable={false}
                />


                : "Avaliar"}</IonButton>

              <div className="status">
                <IonLabel>{value.status}</IonLabel>
                <div className={pisca(value.status)}></div>
              </div>
            </IonCardContent>
          </IonCard>
        )
    );

  }

  function carregarOperacoes() {
    const consultar = async () => {

      requestService(listaOperacao.url, {
        method: listaOperacao.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setArrayOperacoes(response.Items);
          if (response.LastEvaluatedKey) {
            setOperacaopk(response.LastEvaluatedKey.pk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setOperacaopk("");
            setDesabilitarInfiniteScroll(true);
          }
          setShowLoading(false);
        },
        (error: any) => {
          setShowLoading(false);
        });
    }

    consultar();
  }

  async function carregarMaisOperacoes($event: CustomEvent<void>) {

    await carregarMaisOperacoesChamada().then(() => {
      console.log("terminou resultados");
    });
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisOperacoesChamada() {

    requestService(listaOperacao.url + "?pk=" + operacaopk, {
      method: listaOperacao.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(arrayOperacoes.length);
        for (let i = 0; i < response.Items.length; i++) {
          console.log("resultados");
          arrayOperacoes.push(response.Items[i]);
        }
        console.log(arrayOperacoes.length);
        if (response.LastEvaluatedKey) {
          setOperacaopk(response.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setOperacaopk("");
          setDesabilitarInfiniteScroll(true);
          console.log("finalizou");
        }
      },
      (error: any) => {
        console.log(error);
        if (error.status === 426) { // atualizar versao
          history.replace("/atualizar");
        }
        else if (error !== 408) {
          history.replace("/primeiroacesso/");
        }
      });
  }

  function tempoCorrido(horario: Date, horarioFim: Date) {
    var g = Math.ceil((horarioFim.getTime() - horario.getTime()) / 1000 / 60);
    return Math.floor(g / 60).toString() + 'h' + ('0' + (g % 60).toString()).substr(-2) + 'min';
  }

  function doRefresh(event: any) {
    carregarOperacoes();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton>
              <IonIcon slot="icon-only" icon={list} />
            </IonButton>
          </IonButtons>
          <IonTitle>Operações</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={"Operacoes"}>

        <IonSlides className={"OperacoesSlides"} ref={slides} onIonSlideWillChange={nextSlide}>
          <IonSlide key="slide1">
            {loadItens()}
          </IonSlide>
        </IonSlides>

        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisOperacoes(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais operações..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />


      </IonContent>


      <IonModal isOpen={abrirAvaliar} className="my-custom-class Compartilhar" onDidDismiss={() => setAbrirAvaliar(false)}>
        <IonHeader className="headerCompartilhar">
          <IonToolbar color="primary" onClick={() => setAbrirAvaliar(false)}>
            <IonTitle><span className="modal-title-text">Avaliar</span></IonTitle>
            <IonButtons slot="start">
              <IonButton className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" ><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div><br /></div>
          <IonItem lines="full" style={{ "margin-bottom": "20px" }}>
            <IonLabel>
              Avalie sua operação
            </IonLabel>
            <IonIcon hidden={!alertaPreenchimento} src={alertCircle} color="danger" slot="end" />
            <IonNote hidden={!alertaPreenchimento} color="danger" slot="end" style={{ "font-size": "14px" }} >Campo obrigatório</IonNote>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>Escolha de 1 a 5 estrelas para avaliar</IonLabel>

          </IonItem>
          <IonItem lines="full" style={{ "margin-bottom": "20px" }}>
            <div className="avaliarComentar">
              <div className="avaliacaoEstrela">
                <BeautyStars
                  value={valorEstrela}
                  onChange={value => { setAlertaPreenchimento(false); setValorEstrela(value); ajustaTextoEstrela(value); setAbrirAvaliar(true); }}
                  editable={true}
                />
              </div>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              Deixar comentário
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonTextarea rows={3}
              value={comentario}
              style={{ "margin": "5px", "padding": "5px", "border-width": "1px", "border-style": "solid", "border-color": "#e0e0e0", "margin-top": "10px", "margin-right": "10px", "background": "#f2f2f2" }}
              placeholder="Conte-nos o que aconteceu (opcional)"
              onIonChange={e => setComentario(e.detail.value!)}>
            </IonTextarea>
          </IonItem>
        </IonContent>
        <IonFooter className="ion-no-border">
          <IonToolbar >
            <IonButton expand="block" onClick={() => { avaliar() }} >Avaliar</IonButton>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </IonPage>
  );
};

export default Operacoes;
